import { Box, styled } from '@mui/material';

export const EmptyBoxStyled = styled(Box)(({ theme, placeholder }) => ({
  cursor: 'pointer',
  // background: placeholder || theme.palette.background.gray,
  borderRadius: theme.shape.borderRadius,
  aspectRatio: '1 / 1',
}));
